import PropTypes from 'prop-types'
import React from 'react'

import Button from 'components/Button'
import FormCollection from 'components/Form/Collection'
import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import Textarea from 'components/Form/Textarea'

import classes from './EditProduct.scss'

import { makeOptions } from 'helpers/components'
import { compareParseInt, guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

const getType = (props, id) => {
  id = typeof id !== 'undefined' && id || props.fields.type_id.value
  return props.types.find(o => compareParseInt(o.id, id))
}

const getUomOptions = (props) => {
  const type = getType(props)
  const uoms = type && type.uoms && type.uoms.length && type.uoms || props.uoms

  return makeOptions(uoms)
}

const getOptionOptions = (props) => {
  const type = getType(props)
  const options = type && type.options && type.options.length ? type.options : props.options

  return makeOptions(options)
}

export const EditProduct = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Editing Product
        <span className={classes['header-title--unimportant']}> – {props.product.id}</span>
      </div>

      <div className={classes['header-buttons']}>
        <Button submit options={['green', 'small', 'desktop']}>
          Update
        </Button>

        <Button confirm options={['red', 'small']} callback={() => props.handleDelete(props.product.id)}>
          Delete
        </Button>
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />

      <Select label='Product Type'
        placeholder='select a type'
        selectOptions={makeOptions(props.types)}
        {...props.fields.type_id}
      />

      <Select label='Pricelist Category'
        placeholder='select a category'
        subLabel='For searching and filtering on the pricelist.'
        selectOptions={makeOptions(props.categories, 'id', 'name', { sort: 'priority' })}
        {...props.fields.category_id}
      />

      <Select label='Default UOM'
        placeholder='select a unit of measure'
        selectOptions={getUomOptions(props)}
        {...props.fields.default_uom_id}
      />

      <Select label='Default Spec'
        placeholder='select a spec'
        selectOptions={getOptionOptions(props)}
        {...props.fields.default_option_id}
      />

      <Input label='Increment By' placeholder='12' pattern='[0-9]+(\.[0-9]{0,})?' {...props.fields.increment_by} />
      <Input
        label='Increments Allowed'
        placeholder='10'
        subLabel={`This is the max number of increments we'll show in the dropdown ` +
        `(eg. 50 increments of 12 would show up to 600 in the dropdown.`}
        pattern='[0-9]+(\.[0-9]{0,})?'
        {...props.fields.increment_iterations}
      />

      <Checkbox
        label='Available Daily?'
        subLabel='Automatically put product on the pricelist with the settings below (can be overriden).'
        {...props.fields.default_available}
      />

      <FormCollection
        label='Customers'
        subLabel='This product will only be available to these customers.'
        collection={props.fields.customers}
        defaultModel={{ id: undefined }}
        fields={[
          { name: 'id', element: 'select', selectOptions: makeOptions(props.customers), placeholder: 'add customer' }
        ]}
      />
    </fieldset>

    <fieldset>
      <div className={classes['legend--center']}>Default Daily Settings</div>

      <Input label='Scientific Name' placeholder='scientific name' {...props.fields.scientific_name} />
      <Input label='Additional Details' placeholder='sizing, etc' {...props.fields.details} />

      <Input label='Fishing Vessel' placeholder='fishing vessel' {...props.fields.fishing_vessel} />
      <Input label='Sourcing Method' placeholder='sourcing method' {...props.fields.sourcing_method} />
      <Input label='Sourcing Location' placeholder='sourcing location' {...props.fields.sourcing_location} />

      <Textarea label='Tasting Notes' placeholder='tasting notes' {...props.fields.tasting_notes} />

      <FormCollection
        label='Pricing'
        collection={props.fields.prices}
        defaultModel={{ price: undefined, uom_id: undefined, option_id: undefined }}
        fields={[
          { name: 'price', element: 'input', placeholder: 'price', pattern: '[0-9]+(\.[0-9]{0,})?' }, // eslint-disable-line no-useless-escape, max-len
          { name: 'uom_id', element: 'select', selectOptions: getUomOptions(props), placeholder: 'uom' },
          { name: 'option_id', element: 'select', selectOptions: getOptionOptions(props), placeholder: 'spec' }
        ]}
      />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Update Product
      </Button>
    </footer>
  </form>
)

EditProduct.propTypes = {
  product: PropTypes.object.isRequired,

  categories: PropTypes.array.isRequired,
  customers: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  types: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,

  // redux-form
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  handleDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default EditProduct



// WEBPACK FOOTER //
// ./src/components/Products/Edit/EditProduct.js